import { useSelector, useDispatch  } from 'react-redux'
import { closeAlert } from '../../store/slices/alertReducer'
import { Icon } from '@a-ui/react';

import '../../styles/alerts.scss';


const Alerts = (prop) => {
  const { alerts } = useSelector(state => state.alert);
  const dispatch = useDispatch()
  return <div id="alerts">
    { alerts.map((alert) => <div key={`alert-${alert.id}`} role="alertdialog" aria-labelledby="alert-danger" className="m-alert m-alert--danger u-margin-top-xs">
      <div className="u-text-right">
        <Icon name="ai-remove" className="close u-margin-bottom-xs" onClick={() => {
          dispatch(closeAlert(alert.id));
        }}/>
      </div>
      <h4 id="alert-danger" className="h5 u-margin-bottom-xs">{alert.name}{alert.code && ` (${alert.code})`}</h4>
      <p className="">{alert.message}</p>
      <pre>{JSON.stringify(alert, null, 2)}</pre>
    </div>
    ) }
  </div>
}
export default Alerts;
